import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Grid, Row, Col } from 'react-flexbox-grid'
import { Button, Divider, DatePicker } from 'antd'
import moment from "moment";
import './listBidStyles.css'
import BidOrdersTable from '../../containers/BidOrdersTable'
import { getUser } from '../../../reducers'
import { useState } from 'react';
import { message } from 'antd';
import { firestore, db } from '../../../config/Fire'
import * as Constants from '../../../constants'
import { cloudFunctions } from '../../../config/Fire'
import { useHistory } from 'react-router-dom'
import { storage } from 'firebase'
import { generateApprovedQuotationPDF, convertImageToBase64 } from '../../utils/pdfUtils'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import ExcelJS from 'exceljs'
import { saveAs } from 'file-saver'
import { DownloadOutlined } from '@ant-design/icons'

function compareByBumeration (a, b) {
    if (a.numeration < b.numeration) {
        return -1;
    } else if (a.numeration > b.numeration) {
        return 1;
    } else {
        return 0;
    }
}

const ALLOWED_EXPORT_EMAILS = [
    'ingenierosaravia@sdingenieria.com.ar',
    'gabrielsaravia@sdingenieria.com.ar',
    'melinabodini@sdingenieria.com.ar',
    'pruebas@autosolve.com'
]

const ListBids = props => {
    const { works, bids, employees, clients, companyType = 'Arcasa', user } = props
    const [loadingBidOrders, setLoadingBidOrders] = useState(false)
    const history = useHistory();

    const showBidOrder = id => {
        props.onShowBidOrder(id)
    }

    useEffect(() => {
        if (bids && bids.length !== 0) {
            getClientName();
        }
    }, [bids]);

    const getClientName = () => {
        Object.values(bids).forEach(bid => {
            let names = '';
            if (bid.clients) {
                Object.values(bid.clients).forEach(clientId => {
                    const client = clients[clientId];
                    if (client) {
                        names += `${client.name}, `;
                    }
                });
            }
            bid.clientNames = names === '' ? '--' : names;
        });
    };


    const removeBidOrder = record => {
        if (record) {
            setLoadingBidOrders(true)
            storage().ref().child(record.fileUrl).delete()
            firestore.collection(Constants.MAIN_NODES.BID_ORDERS).doc(record.id).delete()
                .then(() => {
                    setLoadingBidOrders(false)
                    message.success('La cotización se borro exitósamente')
                    props.onBidOrderDeleted(record.id)
                })
                .catch(err => {
                    setLoadingBidOrders(false)
                    console.log(err)
                    message.error('Se produjo un error al eliminar la cotización. Por favor, vuelva a intentarlo')
                })
        }
    }

    const generatePDF = async (bidOrder, workOrder) => {
        const doc = new jsPDF();
        const yearLastTwoDigits = workOrder.year.toString().slice(-2);
        
        // Función auxiliar para dibujar el header
        const drawHeader = async (pageNum, totalPages) => {
            try {
                let base64Logo = null
                if (bidOrder.company === 'SD') {
                    base64Logo = await convertImageToBase64("icons/logo_sdosPDF.png");
                    doc.addImage(base64Logo, 'PNG', 14, 12, 35, 15);
                } else {
                    base64Logo = await convertImageToBase64("icons/logo_arcasa.png");
                    doc.addImage(base64Logo, 'PNG', 16, 13, 32, 15);
                }
            } catch (error) {
                console.error("Error al convertir la imagen a base64:", error);
            }

            // Logo y cabecera
            doc.rect(14, 10, 35, 20); // Cuadro para el logo
            doc.setFontSize(12);
            doc.setFont("helvetica", "bold");
            doc.text(`ORDEN DE TRABAJO ${workOrder.workOrderNumber}/${yearLastTwoDigits}`, 105, 19, { align: "center" });
            doc.rect(49, 10, 147, 20); // Cuadro para el título

            // Subcabecera
            doc.setFontSize(10);
            doc.setFont("helvetica", "normal");

            // Cuadro de Número de Revisión
            doc.rect(14, 30, 68, 10);
            doc.text("Número de Revisión: 00", 16, 37);

            // Cuadro de Fecha de Vigencia
            doc.rect(14, 40, 68, 10);
            doc.text("Fecha vigencia: Abril 2015", 16, 47);

            // Cuadro de Página
            doc.rect(82, 30, 68, 20);
            doc.text(`Página ${pageNum} de ${totalPages}`, 115, 40, { align: "center" });

            // Cuadro de Código
            doc.rect(150, 30, 46, 20);
            doc.text("PL02-DG-001", 170, 40, { align: "center" });
        };

        // Variable para rastrear si el contenido se movió a página 2
        let contentMovedToPage2 = false;
        let totalPages = 2; // Por defecto 2 páginas

        // Dibujar header inicial
        await drawHeader(1, totalPages);

        // Posición inicial de la segunda parte
        let y = 55; // Debajo de la cabecera
        const lineHeight = 10; // Altura entre cuadros

        // COMITENTE
        doc.setFont("helvetica", "bold");
        doc.line(14, y, 14, y + lineHeight);
        doc.line(196, y, 196, y + lineHeight);
        doc.line(14, y, 196, y);
        let clients = bidOrder.clientNames ?? '';
        doc.text("COMITENTE:", 16, y + 7);
        doc.setFont("helvetica", "normal");
        doc.text(clients, 90, y + 7);

        y += lineHeight

        // TAREA PROFESIONAL CONTRATADA
        doc.setFont("helvetica", "bold");
        doc.line(14, y, 14, y + lineHeight);
        doc.line(196, y, 196, y + lineHeight);
        doc.text("TAREA PROFESIONAL CONTRATADA:", 16, y + 7);
        doc.setFont("helvetica", "normal");
        doc.text(workOrder.task, 90, y + 7);

        y += lineHeight;

        // UBICACIÓN DE LA TAREA CONTRATADA
        doc.setFont("helvetica", "bold");
        doc.line(14, y, 14, y + lineHeight);
        doc.line(196, y, 196, y + lineHeight);
        doc.text("UBICACIÓN DE LA TAREA CONTRATADA:", 16, y + 7);
        doc.setFont("helvetica", "normal");
        doc.text(`${bidOrder.city} - ${bidOrder.province}`, 90, y + 7);

        y += lineHeight;

        // FECHA
        doc.setFont("helvetica", "bold");
        doc.line(14, y, 14, y + lineHeight);
        doc.line(196, y, 196, y + lineHeight);
        doc.line(14, y + lineHeight, 196, y + lineHeight);
        doc.text("FECHA:", 16, y + 7);
        doc.setFont("helvetica", "normal");
        const date1 = new Date();
        const day1 = date1.getDate();
        const month1 = date1.getMonth() + 1;
        const year1 = date1.getFullYear();
        doc.text(`${day1}/${month1}/${year1}`, 90, y + 7);

        y += lineHeight + 7;

        // ITEMS APROBADOS (antes de NOTA)
        const itemsArray = workOrder.selectedItems || workOrder.items || [];
        if (itemsArray.length > 0) {
            const pageHeight = doc.internal.pageSize.height;
            const minSpaceBeforeFooter = 10;
            const footerHeight = 30;
            const footerY = pageHeight - footerHeight - 10;
            
            // Función para formatear números con separadores de miles
            const formatNumber = (num) => {
                return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            }
            
            // Preparar datos de la tabla
            const tableBody = []
            let totalAmount = 0
            
            itemsArray.forEach((item) => {
                const itemName = item.name || ''
                const itemDescription = item.description || ''
                const days = item.days || item.plazo || item.deadline || ''
                const price = (item.price !== undefined && item.price !== null) ? Number(item.price) : 0
                totalAmount += price
                
                tableBody.push([
                    itemName,
                    itemDescription,
                    days ? days.toString() : '',
                    `$ ${formatNumber(price)}`
                ])
            })
            
            // Agregar fila de total
            tableBody.push([
                '',
                'Total sin IVA',
                '',
                `$ ${formatNumber(totalAmount)}`
            ])
            
            // Título del cuadro
            const titleHeight = 8;
            const titleY = y + titleHeight;
            
            // Verificar espacio aproximado (estimación conservadora)
            const estimatedTableHeight = (tableBody.length + 1) * 8 + 10; // Header + filas + margen
            const estimatedBoxHeight = titleHeight + estimatedTableHeight + 5;
            
            if (y + estimatedBoxHeight > footerY - minSpaceBeforeFooter) {
                contentMovedToPage2 = true;
                totalPages = 3;
                doc.setPage(1);
                await drawHeader(1, totalPages);
                doc.addPage();
                y = 10;
            }
            
            // Dibujar título
            doc.setFont("helvetica", "bold");
            doc.setFontSize(12);
            doc.text("ITEMS APROBADOS:", 16, titleY);
            
            // Generar tabla con autoTable
            // Ancho total disponible: 196 - 14 - 14 = 168 puntos
            const finalY = doc.autoTable({
                startY: titleY + 3,
                head: [['Nombre', 'Descripción', 'Plazo (dias)', 'Monto sin IVA']],
                body: tableBody,
                columnStyles: {
                    0: { cellWidth: 60, cellMinWidth: 60 }, // Nombre - ancho fijo (aumentado)
                    1: { cellWidth: 70, cellMinWidth: 70 }, // Descripción - ancho fijo (aumentado)
                    2: { cellWidth: 22, halign: 'center' }, // Plazo (dias) (aumentado)
                    3: { cellWidth: 30, halign: 'right' } // Monto sin IVA (aumentado)
                },
                headStyles: {
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontStyle: 'bold',
                    lineWidth: 0.5
                },
                styles: {
                    lineWidth: 0.5,
                    lineColor: [0, 0, 0]
                },
                didParseCell: function(data) {
                    // Aplicar negrita a la fila de total
                    if (data.row.raw[1] === 'Total sin IVA') {
                        data.cell.styles.fontStyle = 'bold'
                    }
                },
                margin: { left: 14, right: 14 }
            })
            
            // Actualizar posición Y después de la tabla
            const tableEndY = finalY.lastAutoTable.finalY;
            y = tableEndY + 5;
            
            // Si hay items, agregar página para NOTA, OBSERVACIONES, COTIZACIÓN y Elaborado por
            // Verificar si ya estamos en la página 2 (si los items se movieron)
            const currentPage = doc.internal.getCurrentPageInfo().pageNumber;
            let isOnPage2 = currentPage > 1;
            
            if (!isOnPage2) {
                doc.addPage();
            } else {
                // Si ya estamos en página 2, agregar página 3
                doc.addPage();
            }
            
            // NOTA y OBSERVACIONES en la última página (junto con COTIZACIÓN)
            y = 10; // Empezar desde arriba en páginas sin header
        }
        // Si NO hay items, continuar en la primera página (y se mantiene en la posición actual)
        
        // NOTA
        doc.setFont("helvetica", "bold");
        doc.setFontSize(12);
        doc.line(14, y, 14, y + lineHeight + 15);
        doc.line(196, y, 196, y + lineHeight + 15);
        doc.line(14, y, 196, y);
        doc.text("NOTA:", 16, y + 7);
        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);
        const text = "Los precios que se incluyen para las tareas se actualizarán al momento de la facturación a través del Índice de la CAC. Salvo especificación en cotización enviada.";
        
        // Calcular ancho del label y posición del texto
        doc.setFont("helvetica", "bold");
        const notaLabelWidth = doc.getTextWidth("NOTA:");
        const notaTextStartX = 16 + notaLabelWidth + 4; // Posición después del label
        const notaFirstLineWidth = 196 - notaTextStartX - 2; // Ancho para la primera línea
        const notaFullWidth = 196 - 16 - 2; // Ancho completo para líneas siguientes
        
        // Dividir el texto: primera línea con ancho reducido, resto con ancho completo
        doc.setFont("helvetica", "normal");
        const notaFirstLineSplit = doc.splitTextToSize(text, notaFirstLineWidth);
        let notaTextLines = [];
        if (notaFirstLineSplit.length > 0) {
            notaTextLines.push(notaFirstLineSplit[0]);
            const notaRemainingText = text.substring(notaFirstLineSplit[0].length).trim();
            if (notaRemainingText) {
                const notaRemainingLines = doc.splitTextToSize(notaRemainingText, notaFullWidth);
                notaTextLines.push(...notaRemainingLines);
            }
        }
        
        // Dibujar el texto: primera línea después del label, resto alineado a la izquierda
        if (notaTextLines.length > 0) {
            // Primera línea después del label
            doc.text(notaTextLines[0], notaTextStartX, y + 7);
            
            // Resto de líneas alineadas a la izquierda (x = 16, misma altura que "NOTA:")
            if (notaTextLines.length > 1) {
                const textLineHeight = 5;
                for (let i = 1; i < notaTextLines.length; i++) {
                    doc.text(notaTextLines[i], 16, y + 7 + (i * textLineHeight));
                }
            }
        }

        y += lineHeight + 5;

        // OBSERVACIONES
        // Variables para verificación de espacio
        const pageHeight = doc.internal.pageSize.height;
        const footerHeight = 30;
        const footerY = pageHeight - footerHeight - 10;
        const minSpaceBeforeFooter = 10;
        
        // Calcular altura del texto de observaciones primero
        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);
        // Usar quotationObservations del popup en lugar de observations
        const text2 = workOrder.quotationObservations ?? workOrder.observations ?? '';
        
        // Calcular ancho disponible: desde después de "OBSERVACIONES:" hasta el margen derecho
        const labelText = "OBSERVACIONES:";
        doc.setFont("helvetica", "bold");
        const labelWidth = doc.getTextWidth(labelText);
        const textStartX = 16 + labelWidth + 8; // Posición después del label con más espacio
        const firstLineWidth = 196 - textStartX - 2; // Ancho para la primera línea
        const fullWidth = 196 - 16 - 2; // Ancho completo para líneas siguientes (desde x=16 hasta margen derecho)
        
        // Dividir el texto completo con el ancho completo para calcular todas las líneas
        doc.setFont("helvetica", "normal");
        const allLines = doc.splitTextToSize(text2, fullWidth);
        
        // Si hay texto, ajustar la primera línea para que quepa en el espacio después del label
        let textLines2 = [];
        if (allLines.length > 0 && text2.length > 0) {
            // Primera línea: dividir con el ancho reducido
            const firstLineSplit = doc.splitTextToSize(text2, firstLineWidth);
            if (firstLineSplit.length > 0) {
                textLines2.push(firstLineSplit[0]);
                // Resto del texto con ancho completo
                const remainingText = text2.substring(firstLineSplit[0].length).trim();
                if (remainingText) {
                    const remainingLines = doc.splitTextToSize(remainingText, fullWidth);
                    textLines2.push(...remainingLines);
                }
            }
        }
        
        // Calcular altura del cuadro dinámicamente
        const textLineHeight = 5;
        const paddingTop = 0; // Reducir espacio superior
        const paddingBottom = 5; // Padding pequeño entre texto y línea inferior
        const minHeight = lineHeight + 5;
        const textHeight = textLines2.length * textLineHeight;
        const observationsBoxHeight = Math.max(minHeight, textHeight + paddingTop + paddingBottom);
        
        // Dibujar el cuadro con altura dinámica (sin línea superior)
        doc.setFont("helvetica", "bold");
        doc.setFontSize(12);
        doc.line(14, y, 14, y + observationsBoxHeight);
        doc.line(196, y, 196, y + observationsBoxHeight);
        doc.line(14, y + observationsBoxHeight, 196, y + observationsBoxHeight);
        doc.text(labelText, 16, y + paddingTop + 7);
        
        // Dibujar el texto: primera línea después del label, resto con ancho completo
        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);
        if (textLines2.length > 0) {
            // Primera línea después del label
            doc.text(textLines2[0], textStartX, y + paddingTop + 7);
            
            // Resto de líneas con ancho completo (x = 16, ancho = fullWidth)
            if (textLines2.length > 1) {
                for (let i = 1; i < textLines2.length; i++) {
                    doc.text(textLines2[i], 16, y + paddingTop + 7 + (i * textLineHeight));
                }
            }
        }
        
        y += observationsBoxHeight + 5;
        
        // COTIZACIÓN en la misma página (después de NOTA y OBSERVACIONES)
        const rectHeight1 = 100;
        const rectX1 = 14;
        const rectWidth1 = 185;
        doc.rect(rectX1, y, rectWidth1, rectHeight1);
        doc.setFont("helvetica", "bold");
        doc.setFontSize(12);
        doc.text("COTIZACIÓN:", rectX1 + 5, y + 10);
        doc.text(bidOrder.quotation, rectX1 + 40, y + 10);
        const monthNames = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];
        const date = bidOrder.startDate.split('/').map(Number);
        const monthName = monthNames[date[1] - 1];
        doc.text(`enviada el ${date[0]} de ${monthName} de ${date[2]}`, rectX1 + 85, y + 10);

        try {
            const base64Image = await convertImageToBase64("icons/pdfFirmImage.png");
            doc.addImage(base64Image, 'PNG', rectX1 + 10, y + 25, 180, 70);
        } catch (error) {
            console.error("Error al convertir la imagen a base64:", error);
        }
        
        // Elaborado por en página 2
        const pageHeight2 = doc.internal.pageSize.height;
        const rectHeight = 30;
        const rectY = pageHeight2 - rectHeight - 10;
        const rectX = 14;
        const rectWidth = 185;
        doc.rect(rectX, rectY, rectWidth, rectHeight);

        doc.setFont("helvetica", "bold");
        doc.setFontSize(10);
        doc.text("Elaborado por:", rectX + 5, rectY + 10);
        doc.setFont("helvetica", "normal");
        doc.text("Gerente Técnico", rectX + 5, rectY + 15);

        doc.setFont("helvetica", "bold");
        doc.text("Aprobado por:", rectX + rectWidth - 50, rectY + 10);
        doc.setFont("helvetica", "normal");
        doc.text("Director General", rectX + rectWidth - 50, rectY + 15);

        doc.setFont("helvetica", "bold");
        doc.text("Visado por:", rectX + rectWidth - 50, rectY + 20);
        doc.setFont("helvetica", "normal");
        doc.text("Director General", rectX + rectWidth - 50, rectY + 25);

        return doc;
    }


    const generateWorkOrder = async (bidOrder, selectedItems = [], quotationObservations = '') => {
        if (bidOrder) {
            setLoadingBidOrders(true)
            const paymentTerms = parseInt(bidOrder.paymentTerm) ?? 0
            const expectedCompletionDate = moment().add(paymentTerms, 'days').format('DD/MM/YYYY')
            const year = moment(bidOrder.startDate, 'DD/MM/YYYY').year()

            // Calcular versión consultando works existentes por bidId
            let nextVersion = 1
            try {
                const existingWorks = await firestore
                    .collection(Constants.MAIN_NODES.WORK_ORDERS)
                    .where('bidId', '==', bidOrder.id)
                    .get()
                
                if (!existingWorks.empty) {
                    const versions = existingWorks.docs
                        .map(doc => {
                            const data = doc.data()
                            // Si el work no tiene version, asumimos que es version 1 (registros viejos)
                            return data.version || 1
                        })
                    nextVersion = Math.max(...versions, 0) + 1
                }
            } catch (error) {
                console.error('Error al calcular versión:', error)
                // Si hay error, usar versión 1 por defecto
            }

            let currentYear = new Date().getFullYear()
            let maxWorkOrderNumber = Object.values(works)
                .filter(work => work.year === currentYear && work.company === bidOrder.company)
                .reduce((max, work) => Math.max(max, work.workOrderNumber), 0)
            let nextWorkOrderNumber = maxWorkOrderNumber + 1;
            const nDate = new Date();
            const workOrder = {
                startDate: `${nDate.getDate()}/${nDate.getMonth() + 1}/${nDate.getFullYear()}`,
                year: year ?? 0,
                clientIds: bidOrder.clients ?? [],
                locality: bidOrder.city ?? '',
                observations: '',
                quotationObservations: quotationObservations || '',
                completionPercentage: 0,
                outsourced: bidOrder.outsourcing?.length > 0 ? true : false,
                delivered: false,
                effectiveEndDate: '',
                expectedCompletionDate: expectedCompletionDate ?? '',
                workOrderNumber: nextWorkOrderNumber,
                task: bidOrder.proyect ?? '',
                professionalIds: [],
                percentagesPerArea: [],
                areas: [],
                category: bidOrder.category ?? '',
                company: bidOrder.company ?? '',
                SAT: bidOrder.SAT !== undefined ? bidOrder.SAT : false,
                bidId: bidOrder.id ?? '',
                version: nextVersion,
                hasTopography: bidOrder.hasTopography === true ? 'Pendiente de viaje' : bidOrder.hasTopography === false ? 'No contempla' : bidOrder.hasTopography,
            }
            
            // Agregar selectedItems si existen
            if (selectedItems && Array.isArray(selectedItems) && selectedItems.length > 0) {
                workOrder.selectedItems = selectedItems
            }

            const doc = await generatePDF(bidOrder, workOrder);
            cloudFunctions.newWorkOrder(workOrder)
            .then(async response => {
                if (response.data && response.data.code !== undefined && response.data.code === 0 && response.data.workOrder !== undefined) {
                    let fileUrl = `works/${response.data.workOrder.id}/OT.pdf`
                    const pdfRef = storage().ref().child(fileUrl)
                    pdfRef.put(doc.output('blob')).then(() => {
                        pdfRef.getDownloadURL().then(url => {
                            firestore.collection(Constants.MAIN_NODES.WORK_ORDERS).doc(response.data.workOrder.id).update({fileUrl: fileUrl})
                        })
                    })

                    // Ya no actualizamos workOrderId en el bid - ahora la relación es solo por bidId en works
                    const workOrderLabel = getOTLabel(response.data.workOrder)
                    response.data.workOrder.workOrderLabel = workOrderLabel
                    const data = {
                        workOrderID: response.data.workOrder.id,
                        type: 'OT_CREATED',
                        detailsOT: response.data.workOrder,
                    }
                    cloudFunctions.sendEmails(data)
                    setLoadingBidOrders(false)
                    message.success('¡La orden de trabajo se guardó exitósamente!')
                    props.onBack(true, response.data.workOrder.id, bidOrder)
                    history.push(`/editar_trabajo/${response.data.workOrder.id}`)
                } else {
                    setLoadingBidOrders(false)
                    console.log(response)
                    message.error('Se produjo un error al guardar la orden de trabajo. Por favor, vuelva a intentarlo')
                }
            })
            .catch(err => {
                setLoadingBidOrders(false)
                console.log(err)
                message.error('Se produjo un error al guardar la orden de trabajo. Por favor, vuelva a intentarlo')
            })
        }
    }

    const getOTLabel = (prop) => {
        const company = prop?.company === 'SD' ? 'SYD' : prop?.company === 'Arcasa' ? 'ARC' : 'O/T'
        if (prop.SAT) {
            return `${company} Nº${prop['workOrderNumber']}/${prop['year'].toString().substring(2, 4)} (SAT)`
        } else { 
            return `${company} Nº${prop['workOrderNumber']}/${prop['year'].toString().substring(2, 4)}`
        }
    }

    const getWorksForBid = (bidId) => {
        if (!works || !bidId) return []
        const worksByBidId = Object.values(works).filter(work => work.bidId === bidId)
        return worksByBidId.sort((a, b) => {
            const versionA = a.version || 1
            const versionB = b.version || 1
            return versionA - versionB
        })
    }

    const hasWorks = (record) => {
        if (record.workOrderId) {
            return true
        }
        const worksForBid = getWorksForBid(record.id)
        return worksForBid.length > 0
    }

    const getOTLabelFromWork = (work) => {
        if (!work) return '--'
        const company = work?.company === 'SD' ? 'SYD' : work?.company === 'Arcasa' ? 'ARC' : 'O/T'
        const version = work.version ? ` v${work.version}` : ''
        if (work.SAT) {
            return `${company} Nº${work['workOrderNumber']}/${work['year']?.toString().substring(2, 4)} (SAT)${version}`
        } else {
            return `${company} Nº${work['workOrderNumber']}/${work['year']?.toString().substring(2, 4)}${version}`
        }
    }

    const exportBidsToExcel = async () => {
        try {
            message.loading({ content: 'Generando Excel de Cotizaciones...', key: 'excel_bids' })
            const bidList = (bids && Object.keys(bids).length !== 0)
                ? Object.values(bids).sort(compareByBumeration)
                : []

            if (bidList.length === 0) {
                message.warning({ content: 'No hay cotizaciones para exportar', key: 'excel_bids' })
                return
            }

            const workbook = new ExcelJS.Workbook()
            const worksheet = workbook.addWorksheet('Cotizaciones')

            const titleRow = worksheet.addRow([`COTIZACIONES - ${companyType.toUpperCase()}`])
            worksheet.mergeCells('A1:L1')
            const titleCell = titleRow.getCell(1)
            titleCell.font = { name: 'Calibri', size: 14, bold: true, color: { argb: 'FFFFFFFF' } }
            titleCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF1B365D' } }
            titleCell.alignment = { horizontal: 'center', vertical: 'middle' }
            titleRow.height = 30

            const dateStr = moment().format('DD/MM/YYYY HH:mm')
            const subTitleRow = worksheet.addRow([`Fecha de generación: ${dateStr}`])
            worksheet.mergeCells('A2:L2')
            const subTitleCell = subTitleRow.getCell(1)
            subTitleCell.font = { name: 'Calibri', size: 10, italic: true, color: { argb: 'FF555555' } }
            subTitleCell.alignment = { horizontal: 'right', vertical: 'middle' }
            subTitleRow.height = 18

            worksheet.addRow([])

            const headers = [
                'Número de cotización',
                'Fecha de cotización',
                'Cliente',
                'Descripción',
                'Área/Rubro',
                'Importe cotizado',
                'Estado',
                'Fecha de contratación',
                'Importe contratado',
                'OT generada',
                'Tipo de cliente',
                'Días de ingeniería'
            ]
            const headerRow = worksheet.addRow(headers)
            headerRow.height = 25

            const headerFill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF263238' } }
            const headerFont = { name: 'Calibri', size: 11, bold: true, color: { argb: 'FFFFFFFF' } }
            const borderStyle = {
                top: { style: 'thin', color: { argb: 'FFD3D3D3' } },
                left: { style: 'thin', color: { argb: 'FFD3D3D3' } },
                bottom: { style: 'thin', color: { argb: 'FFD3D3D3' } },
                right: { style: 'thin', color: { argb: 'FFD3D3D3' } }
            }

            headerRow.eachCell(cell => {
                cell.fill = headerFill
                cell.font = headerFont
                cell.alignment = { horizontal: 'center', vertical: 'middle' }
                cell.border = borderStyle
            })

            bidList.forEach((bid, index) => {
                const worksForBid = getWorksForBid(bid.id)
                let legacyWork = null
                if (works && bid.workOrderId && works[bid.workOrderId]) {
                    legacyWork = works[bid.workOrderId]
                    if (!worksForBid.find(w => w.id === legacyWork.id)) {
                        worksForBid.push(legacyWork)
                    }
                }

                const isHired = hasWorks(bid)
                const estado = isHired ? 'Contratada' : 'Pendiente'
                
                let fechaContratacion = '--'
                let importeContratado = '--'
                let otGenerada = '--'

                if (isHired && worksForBid.length > 0) {
                    fechaContratacion = worksForBid.map(w => w.startDate || '--').join('\n')
                    otGenerada = worksForBid.map(w => getOTLabelFromWork(w)).join('\n')
                    
                    importeContratado = worksForBid.map(w => {
                        let total = 0
                        if (w.selectedItems && Array.isArray(w.selectedItems)) {
                            total = w.selectedItems.reduce((sum, item) => sum + (Number(item.price) || 0), 0)
                        } else if (w.items && Array.isArray(w.items)) {
                            total = w.items.reduce((sum, item) => sum + (Number(item.price) || 0), 0)
                        }
                        return total > 0 ? `$ ${total.toFixed(2)}` : '--'
                    }).join('\n')
                }
                
                let importeCotizado = ''
                if (bid.amountPesos) importeCotizado += `$ ${bid.amountPesos}`
                if (bid.amountDollars) importeCotizado += (importeCotizado ? ' / ' : '') + `USD ${bid.amountDollars}`
                if (!importeCotizado) importeCotizado = '--'

				const itemsDaysSum = Array.isArray(bid.items)
					? bid.items.reduce((sum, item) => sum + (Number(item?.days) || 0), 0)
					: 0

				const rawEngineeringDays =
					bid.quotedEngineeringDays !== undefined &&
					bid.quotedEngineeringDays !== null &&
					bid.quotedEngineeringDays !== '' &&
					!Number.isNaN(Number(bid.quotedEngineeringDays))
						? Number(bid.quotedEngineeringDays)
						: bid.totalDays && Number(bid.totalDays) > 0
							? Number(bid.totalDays)
							: itemsDaysSum > 0
								? itemsDaysSum
								: null

				const diasIngenieria = rawEngineeringDays !== null ? rawEngineeringDays : '--'

                const clientTypes = []
                if (bid.clients && Array.isArray(bid.clients)) {
                    bid.clients.forEach(clientId => {
                        const client = clients && clients[clientId]
                        if (client && client.type !== undefined) {
                            clientTypes.push(client.type ? 'Privado' : 'Público')
                        }
                    })
                }
                const clientType = clientTypes.length > 0 ? clientTypes.join(', ') : '--'

                const rowData = [
                    bid.quotation || '--',
                    bid.startDate || '--',
                    bid.clientNames || '--',
                    bid.proyect || '--',
                    bid.category || '--',
                    importeCotizado,
                    estado,
                    fechaContratacion,
                    importeContratado,
                    otGenerada,
                    clientType,
                    diasIngenieria
                ]

                const row = worksheet.addRow(rowData)
                row.height = 22

                const isEven = index % 2 === 0
                const rowFill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: isEven ? 'FFFFFFFF' : 'FFF4F6F8' }
                }

                row.eachCell((cell, colNumber) => {
                    cell.fill = rowFill
                    cell.border = borderStyle
                    cell.font = { name: 'Calibri', size: 10 }
                    
                    if ([1, 2, 7, 8, 10, 11, 12].includes(colNumber)) {
                        cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true }
                    } else {
                        cell.alignment = { horizontal: 'left', vertical: 'middle', wrapText: true }
                    }
                })
            })

            worksheet.getColumn(1).width = 20
            worksheet.getColumn(2).width = 15
            worksheet.getColumn(3).width = 30
            worksheet.getColumn(4).width = 40
            worksheet.getColumn(5).width = 25
            worksheet.getColumn(6).width = 20
            worksheet.getColumn(7).width = 15
            worksheet.getColumn(8).width = 15
            worksheet.getColumn(9).width = 20
            worksheet.getColumn(10).width = 25
            worksheet.getColumn(11).width = 15
            worksheet.getColumn(12).width = 15

            const buffer = await workbook.xlsx.writeBuffer()
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
            const fileDate = moment().format('DD-MM-YYYY')
            saveAs(blob, `Cotizaciones_${companyType}_${fileDate}.xlsx`)
            message.success({ content: 'Excel descargado exitosamente', key: 'excel_bids' })
        } catch (err) {
            console.error('Error exporting bids to Excel:', err)
            message.error({ content: 'Error al generar el archivo Excel', key: 'excel_bids' })
        }
    }
    return (
        <Grid className="listBidsCont">
            <Row center="xs">
                <Col xs={12}>
                    <h2>Cotizaciones {companyType}</h2>
                </Col>
            </Row>
            <Divider/>
            <div style={{ position: 'relative', marginBottom: '15px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Button className="newBidOrderButton" onClick={props.onNewBidSelected} type="primary" size="large">Nueva cotización</Button> 
                {user && user.email && ALLOWED_EXPORT_EMAILS.includes(user.email) && (
                    <div style={{ position: 'absolute', right: '0px' }}>
                        <Button
                            type="primary"
                            icon={<DownloadOutlined />}
                            onClick={exportBidsToExcel}
                            style={{ backgroundColor: '#2e7d32', borderColor: '#2e7d32' }}
                        >
                            Descargar excel
                        </Button>
                    </div>
                )}
            </div>
            <Row center="xs">
                <Col xs={12}>
                    <BidOrdersTable data={(bids && bids !== null) ? Object.values(bids).sort(compareByBumeration) : []}
                        clients={clients} outsourcing={props.outsourcing}
                        employees={employees} onShowBidOrder={showBidOrder}
                        onRemoveBidOrder={removeBidOrder} loading={loadingBidOrders}
                        onGenerateWorkOrder={generateWorkOrder} works={works}/>
                </Col>
            </Row>
        </Grid>
    )
}

ListBids.propTypes = {
}

const mapDispatchToPropsActions = dispatch => ({})

const mapStateToProps = state => ({
    user: getUser(state)
})

export default connect(mapStateToProps, mapDispatchToPropsActions)(ListBids)